import ATBodyItem from './ATBodyItem';
import BusBodyItem from './BusBodyItem';
import { KuposCommonLoader } from '../../../common';
import KuposGoBodyItem from './KuposGoBodyItem';
import React from 'react';
import TrainBodyItem from './TrainBodyItem';

function BodyItem(props) {
  switch (props.type) {
    case 'bus':
      return (
        <div>
          {props.data.getMyTripsBusPending ? (
            <div className="my-trips-loader">
              <KuposCommonLoader />
            </div>
          ) : null}
          {props.data.myTripsBus &&
          props.data.myTripsBus.body &&
          props.data.myTripsBus.body.transactions
            ? props.data.myTripsBus.body.transactions.map((val, key) => {
                return (
                  <BusBodyItem
                    val={val}
                    keyValue={key}
                    onSeeMoreClickedBus={props.onSeeMoreClickedBus}
                    selectedTripItem={props.selectedTripItem}
                    // selectedTripItem={props.selectedTripItem}
                    ticketDetailsBus={props.ticketDetailsBus}
                    busTicketLoading={props.busTicketLoading}
                    t={props.t}
                    notIspast={props.notIspast}
                    cancelBusTicket={props.cancelBusTicket}
                    busTicketCancellationLoading={props.busTicketCancellationLoading}
                  />
                );
              })
            : !props.data.getMyTripsBusPending
            ? props.renderNoTripsFound('/images/icons/home/grey_icon_bus.png', '/', 0)
            : null}
        </div>
      );
      break;
    case 'car':
      return props.renderNoTripsFound('/images/icons/home/grey_icon_car.png', '/', 1, true);
    case 'at':
      return (
        <div>
          {props.data.getMyAtTripsPending ? (
            <div className="my-trips-loader">
              <KuposCommonLoader />
            </div>
          ) : null}
          {props.data.myAtTrips && props.data.myAtTrips.data && props.data.myAtTrips.data
            ? props.data.myAtTrips.data.map((val, key) => (
                <ATBodyItem
                  val={val}
                  keyValue={key}
                  t={props.t}
                  ticketDetailsAt={props.ticketDetailsAt}
                  data={props.data}
                  notIspast={props.notIspast}
                  onSeeMoreClickedAT={props.onSeeMoreClickedAT}
                  selectedTripItem={props.selectedTripItem}
                  busTicketLoading={props.busTicketLoading}
                  cancelBusTicket={props.cancelBusTicket}
                  busTicketCancellationLoading={props.busTicketCancellationLoading}
                />
              ))
            : !props.data.getMyAtTripsPending
            ? props.renderNoTripsFound(
                '/images/icons/home/airport-transfer-grey_circle.png',
                '/',
                2,
              )
            : null}
        </div>
      );
    case 'train':
      return (
        <div>
          {props.data.getmyTripsTrainPending ? (
            <div className="my-trips-loader">
              <KuposCommonLoader />
            </div>
          ) : null}
          {props.data.myTripsTrain &&
          props.data.myTripsTrain.body &&
          props.data.myTripsTrain.body.transactions
            ? props.data.myTripsTrain.body.transactions.map((val, key) => (
                <TrainBodyItem
                  val={val}
                  keyValue={key}
                  t={props.t}
                  onSeeMoreClickedBus={props.onSeeMoreClickedBus}
                  selectedTripItem={props.selectedTripItem}
                  busTicketLoading={props.busTicketLoading}
                  ticketDetailsBus={props.ticketDetailsBus}
                />
              ))
            : !props.data.getmyTripsTrainPending
            ? props.renderNoTripsFound('/images/icons/home/grey_icon_train.png', '/', 3)
            : null}
        </div>
      );
    case 'ss':
      return (
        <div>
          {props.data.getMyAtTripsPending ? (
            <div className="my-trips-loader">
              <KuposCommonLoader />
            </div>
          ) : null}
          {props.data.kuposGoTrips &&
          props.data.kuposGoTrips.body &&
          props.data.kuposGoTrips.body.transactions
            ? props.data.kuposGoTrips.body.transactions.map((val, key) => (
                <KuposGoBodyItem
                  value={val}
                  keyValue={key}
                  BusTicketLoading={props.BusTicketLoading}
                  ticketDetailsKuposGo={props.ticketDetailsKuposGo}
                  onSeeMoreClickedKuposGo={props.onSeeMoreClickedKuposGo}
                  selectedTripItem={props.selectedTripItem}
                />
              ))
            : !props.data.getKuposGoTripsPending
            ? props.renderNoTripsFound('/images/icons/home/icon_kupos-go_grey.png', '/', 5)
            : null}
        </div>
      );
    default:
      return props.renderNoTripsFound('/images/icons/home/grey_icon_bus.png', '/', 0);
  }
}

export default BodyItem;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyTrips/components/BodyItem.js